import { Observable } from 'rxjs';
import { Comprobante } from './model';

export abstract class AccountingRepository {
  abstract createComprobante(comprobante: Partial<Comprobante>): Observable<Comprobante>;
  abstract getComprobante(id: number): Observable<Comprobante>;
  abstract getComprobantes(page: number, limit: number): Observable<Comprobante[]>;
  abstract getComprobantesById(id: number): Observable<any>;
  abstract updateComprobante(id: number, comprobante: Partial<Comprobante>): Observable<Comprobante>;
  abstract deleteComprobante(id: number): Observable<void>;
  abstract getDocumentTypes(): Observable<any>;

  abstract getClosingStatus(year: number): Observable<any>;
  abstract calculateClosing(data: any): Observable<any>;
  abstract approveClosing(data: any): Observable<any>;

  abstract getCostingStatus(year: number, month: number): Observable<any>;
  abstract calculateCosting(data: any): Observable<any>;
  abstract approveCosting(data: any): Observable<any>;

  abstract getTaxClosingStatus(year: number, month: number): Observable<any>;
  abstract calculateTaxClosing(data: any): Observable<any>;
  abstract approveTaxClosing(data: any): Observable<any>;
}
